/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    Datagrid,
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    UrlField,
    SimpleShowLayout,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';

export const ProfessionalBodyLabels = {
    pageTitle: 'Professional Bodies',
    createTitle: 'Create Professional Body',
    is_kis: 'Is KIS',
};

export const ProfessionalBodyList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={ProfessionalBodyLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="Title" />
                    <TextField source="code" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const ProfessionalBodyCreate = (props) => (
    <Create title={ProfessionalBodyLabels.createTitle} {...props}>
        <ProfessionalBodyInputForm {...props} />
    </Create>
);

export const ProfessionalBodyEdit = (props) => (
    <Edit {...props} redirect="edit">
        <ProfessionalBodyInputForm {...props} />
    </Edit>
);

export const ProfessionalBodyShow = (props) => (
    <Show title={<ShowTitleByTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" />
            <TextField source="code" />
            <UrlField source="url" />
            <BooleanField source="current" />
            <BooleanField
                label={ProfessionalBodyLabels.is_kis}
                source="is_kis"
            />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);

const ProfessionalBodyInputForm = (source) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SimpleForm {...source} toolbar={<EditToolbar />}>
                <TextInput source="id" disabled />
                <br />
                <TextInput source="Title" />
                <br />
                <TextInput source="code" />
                <br />
                <TextInput source="url" />
                <br />
                <BooleanInput source="current" />
                <br />
                <BooleanInput
                    label={ProfessionalBodyLabels.is_kis}
                    source="is_kis"
                />
                <br />
            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};
